import React, { Component } from 'react';
import { BrowserRouter, Route } from "react-router-dom";

import Login from './components/Login/Login';
import LiveMap from './components/LiveMap';

export default class Router extends Component {
    render(){
        return (
            <BrowserRouter>
                    
                    <Route path="/" exact component={Login} />
                    <Route path="/map/" exact component={LiveMap} />
         
            </BrowserRouter>
        )
            
    }
}


